var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.089,
    height: 18.089,
    viewBox: "0 0 18.089 18.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M27,23.625h1.254V26.76H27Z",
    transform: "translate(-13.19 -11.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6_-_Outline",
    "data-name": "Path 6 - Outline",
    d: "M27.018,23.375h1.254a.268.268,0,0,1,.268.268v3.135a.268.268,0,0,1-.268.268H27.018a.268.268,0,0,1-.268-.268V23.643A.268.268,0,0,1,27.018,23.375ZM28,23.91h-.719v2.6H28Z",
    transform: "translate(-13.208 -11.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M22.5,18h1.254v6.269H22.5Z",
    transform: "translate(-11.198 -9.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7_-_Outline",
    "data-name": "Path 7 - Outline",
    d: "M22.518,17.75h1.254a.268.268,0,0,1,.268.268v6.269a.268.268,0,0,1-.268.268H22.518a.268.268,0,0,1-.268-.268V18.018A.268.268,0,0,1,22.518,17.75Zm.986.535h-.719v5.734H23.5Z",
    transform: "translate(-11.216 -9.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M9.885,24.269A3.138,3.138,0,0,1,6.75,21.135H8a1.881,1.881,0,1,0,1.881-1.881V18a3.135,3.135,0,0,1,0,6.269Z",
    transform: "translate(-4.225 -9.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8_-_Outline",
    "data-name": "Path 8 - Outline",
    d: "M9.9,24.554h0a3.412,3.412,0,0,1-3.4-3.4.268.268,0,0,1,.268-.268H8.021a.268.268,0,0,1,.268.268A1.613,1.613,0,1,0,9.9,19.539a.268.268,0,0,1-.268-.268V18.018A.268.268,0,0,1,9.9,17.75a3.4,3.4,0,0,1,0,6.8ZM7.048,21.42a2.877,2.877,0,0,0,2.855,2.6h0A2.867,2.867,0,0,0,10.17,18.3v.723a2.148,2.148,0,1,1-2.4,2.4Z",
    transform: "translate(-4.242 -9.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M18.55,2.25H3.5A1.255,1.255,0,0,0,2.25,3.5V18.55A1.255,1.255,0,0,0,3.5,19.8H18.55A1.255,1.255,0,0,0,19.8,18.55V3.5A1.255,1.255,0,0,0,18.55,2.25Zm0,5.642H9.773V3.5H18.55ZM8.519,3.5V7.892H3.5V3.5ZM3.5,18.55v-9.4H18.55v9.4Z",
    transform: "translate(-2.232 -2.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9_-_Outline",
    "data-name": "Path 9 - Outline",
    d: "M3.521,2H18.567a1.525,1.525,0,0,1,1.521,1.521V18.567a1.526,1.526,0,0,1-1.521,1.521H3.521A1.525,1.525,0,0,1,2,18.568V3.521A1.525,1.525,0,0,1,3.521,2ZM18.567,19.554a.99.99,0,0,0,.986-.987V3.521a.989.989,0,0,0-.987-.986H3.522a.989.989,0,0,0-.987.987V18.567a.989.989,0,0,0,.987.986ZM3.521,3.254H8.537a.268.268,0,0,1,.268.268V7.91a.268.268,0,0,1-.268.268H3.521a.268.268,0,0,1-.268-.268V3.521A.268.268,0,0,1,3.521,3.254Zm4.748.535H3.789V7.642h4.48Zm1.521-.535h8.777a.268.268,0,0,1,.268.268V7.91a.268.268,0,0,1-.268.268H9.791a.268.268,0,0,1-.268-.268V3.521A.268.268,0,0,1,9.791,3.254Zm8.509.535H10.058V7.642H18.3ZM3.521,8.9H18.567a.268.268,0,0,1,.268.268v9.4a.268.268,0,0,1-.268.268H3.521a.268.268,0,0,1-.268-.268v-9.4A.268.268,0,0,1,3.521,8.9ZM18.3,9.431H3.789V18.3H18.3Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.54aaf0c070349b9779fb5e0361b81c65.svg";
export { ForwardRef as ReactComponent };